import { render, staticRenderFns } from "./pptfx.vue?vue&type=template&id=a15d26e6&"
import script from "./pptfx.vue?vue&type=script&lang=js&"
export * from "./pptfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports